import { render } from "./MainProductMovement.vue?vue&type=template&id=aa720a42&scoped=true"
import script from "./MainProductMovement.vue?vue&type=script&lang=js"
export * from "./MainProductMovement.vue?vue&type=script&lang=js"

import "./MainProductMovement.vue?vue&type=style&index=0&id=aa720a42&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa720a42"]])

export default __exports__